module.exports = __webpack_public_path__ + "img/Menu-05.03208c69.png";